import { render, staticRenderFns } from "./ImplantsMenu.vue?vue&type=template&id=025a0330&scoped=true&"
import script from "./ImplantsMenu.vue?vue&type=script&lang=js&"
export * from "./ImplantsMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "025a0330",
  null
  
)

export default component.exports